export const LIST_SE360_USERS_SUCCESS = 'LIST_SE360_USERS_SUCCESS';
export const LIST_SE360_USERS_FAILURE = 'LIST_SE360_USERS_FAILED';

export const NEW_SE360_USER_SUCCESS = 'NEW_SE360_USER_SUCCESS';
export const NEW_SE360_USER_FAILURE = 'NEW_SE360_USER_FAILURE';

export const CREATE_SE360_USER_SUCCESS = 'CREATE_SE360_USER_SUCCESS';
export const CREATE_SE360_USER_FAILURE = 'CREATE_SE360_USER_FAILURE';

export const EDIT_SE360_USER_SUCCESS = 'EDIT_SE360_USER_SUCCESS';
export const EDIT_SE360_USER_FAILURE = 'EDIT_SE360_USER_FAILURE';

export const UPDATE_SE360_USER_SUCCESS = 'UPDATE_SE360_USER_SUCCESS';
export const UPDATE_SE360_USER_FAILURE = 'UPDATE_SE360_USER_FAILURE';

export const DELETE_SE360_USER_SUCCESS = 'DELETE_SE360_USER_SUCCESS';
export const DELETE_SE360_USER_FAILURE = 'DELETE_SE360_USER_FAILURE';

export const RESTORE_SE360_USER_SUCCESS = 'RESTORE_SE360_USER_SUCCESS';
export const RESTORE_SE360_USER_FAILURE = 'RESTORE_SE360_USER_FAILURE';
